import { render, staticRenderFns } from "./novnc-window.vue?vue&type=template&id=24d3d485&scoped=true"
import script from "./novnc-window.vue?vue&type=script&lang=js"
export * from "./novnc-window.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d3d485",
  null
  
)

export default component.exports